import { defineMeta } from '@/registry/types';

export const statTileMeta = defineMeta({
  name: 'StatTile',
  level: 'molecule',
  category: 'data-display',
  classification: 'custom',
  description:
    'Headline figure with optional delta and trend. Renders the `kpi` chart type without instantiating a chart.',
  baseLibrary: 'custom',
  importPath: '@/molecules/StatTile',
  requiredProps: ['value', 'label'],
  optionalProps: ['caption', 'delta', 'deltaPolarity', 'trend'],
  supportedStates: ['default', 'with-delta', 'with-trend'],
  designTokens: ['chart', 'severity', 'typography'],
  accessibility: [
    'Delta direction is carried by an arrow glyph and sign, not by colour alone.',
    'The embedded Sparkline receives a derived aria-label naming the metric.',
  ],
  usageExamples: [
    '<StatTile value="1,284" label="Open alerts" delta={-12.4} deltaPolarity="lowerIsBetter" />',
    '<StatTile value="98.2%" label="Detection coverage" trend={[91, 93, 96, 98]} />',
  ],
  rules: [
    'The label is body1, the figure is h3, the delta is body2, the caption is caption. Pass them as props — do not wrap the value in Typography.',
  ],
  antiPatterns: ['Do not use for more than one measure — use a chart.'],
  mountsSurface: 'inline',
  llmSafe: true,
  whenToUse: ['A single headline number on a dashboard or report'],
  whenNotToUse: ['Comparisons across categories or time series detail'],
});

export default statTileMeta;
